import { render, staticRenderFns } from "./TicketLists.vue?vue&type=template&id=0dff8da3"
import script from "./TicketLists.vue?vue&type=script&lang=js"
export * from "./TicketLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports